export default __webpack_public_path__ + "static/media/startTradeIcon2.3a35619a.webp";